// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XKanban_XComponent__kZX-0, div.XKanban_XKanban__SsqEK, div.XKanban_XKanbanSticker__cBnbl {
  margin-left: var(--margin-left);
  margin-right: var(--margin-right);
  margin-top: var(--margin-top);
  margin-bottom: var(--margin-bottom);
}

div.XKanban_XKanban__SsqEK {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  flex: content;
  flex-grow: 1;
  margin: 5px;
  border-color: black;
  border-width: 5px;
  border-radius: 5px;
  border-style: solid;
  height: 600px;
}

div.XKanban_XKanbanSticker__cBnbl {
  flex-shrink: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  flex: content;
  flex-grow: 1;
  margin: 5px;
  max-width: 350px;
  border-color: lime;
  border-width: 5px;
  border-radius: 5px;
  border-style: solid;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/X/components/commons/XComponent.module.scss","webpack://./src/X/components/kanban/XKanban.module.scss","webpack://./src/X/styles/common.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;EACA,iCAAA;EACA,6BAAA;EACA,mCAAA;ACCJ;;AADA;ECMI,cAAA;EDFA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EAGA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAAJ;;AAIA;ECbI,cAAA;EAAA,cAAA;EDiBA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EAGA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,UAAA;AALJ","sourcesContent":[".XComponent {\r\n    margin-left: var(--margin-left);\r\n    margin-right: var(--margin-right);\r\n    margin-top: var(--margin-top);\r\n    margin-bottom: var(--margin-bottom);\r\n}","@use \"../../styles/common\";\r\n@use \"../../styles/themes\";\r\n@use '../commons/XComponent.module.scss';\r\n\r\ndiv.XKanban {\r\n    //@include common.debug;\r\n    @extend .XComponent;\r\n    @include common.noshrink;\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex: content;\r\n    flex-grow: 1;\r\n    margin: 5px;\r\n\r\n    //debug\r\n    border-color: black;\r\n    border-width: 5px;\r\n    border-radius: 5px;\r\n    border-style: solid;\r\n    height: 600px;\r\n}\r\n\r\n\r\ndiv.XKanbanSticker {\r\n    @extend .XComponent;\r\n    @include common.noshrink;\r\n    @include common.noshrink;\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: content;\r\n    flex-grow: 1;\r\n    margin: 5px;\r\n    max-width: 350px;\r\n\r\n    //debug\r\n    border-color: lime;\r\n    border-width: 5px;\r\n    border-radius: 5px;\r\n    border-style: solid;\r\n\r\n    z-index: 1;\r\n}","\n@mixin nodebug\n{\n    outline-width: 0px;\n    outline-color: chartreuse;\n    outline-style: none;\n}\n\n@mixin noshrink\n{\n    flex-shrink: 0;\n}\n\n@mixin noselect {\n    -webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n@mixin nomouse {\n    pointer-events: none;\n}\n\n@mixin border-box {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XComponent": `XKanban_XComponent__kZX-0`,
	"XKanban": `XKanban_XKanban__SsqEK`,
	"XKanbanSticker": `XKanban_XKanbanSticker__cBnbl`
};
export default ___CSS_LOADER_EXPORT___;
